import DIContainer from '@components/DependencyInjectionContainer.js';
function handler() {
    return DIContainer.getInstance('UrlHandler');
}
export function absoluteURL(input) {
    return handler().absoluteURL(input);
}
export function isExternalUrl(url) {
    return handler().isExternalUrl(url);
}
export function paramsFromUrlGet(url) {
    return handler().paramsFromUrlGet(url);
}
export function parseResqZoomForm(xmlString) {
    return handler().parseResqZoomForm(xmlString);
}
export function convertLegacyQ360Url(url) {
    return handler().convertLegacyQ360Url(url);
}
export function zoomHandler(urlTemplate, options) {
    return handler().zoom(urlTemplate, options);
}
